export const isNull = (value) => value === null
export const isNan = (value) => Number.isNaN(value)
export const isUndefined = (value) => value === undefined
export const isBoolean = (value) => typeof value === 'boolean'
export const isArray = (value) => Array.isArray(value)
export const isString = (value) => typeof value === 'string'
export const isNumber = (value) => typeof value === 'number' && !isNan(value)
export const isObject = (value) => typeof value === 'object' && !Array.isArray(value) && value !== null
export const isHas = (obj, prop) => obj.hasOwnProperty(prop)
export const isNullOrUndefined = (value) => value === null || value === undefined
